import { useEffect } from 'react';
import type { AppEvent, Listener } from '@/types/event-emitter.types';
import { emitter } from '@/utils/event-emitter';

const useEmitter = <K extends AppEvent>(event: K, handler: Listener<K>) => {
	useEffect(() => {
		const unsubscribe = emitter.on(event, handler);
		return () => unsubscribe();
	}, [event, handler]);
};

export default useEmitter;
